"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ApplePayScript = require("./ApplePayScript");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ApplePayRequest = _interopRequireDefault(require("./ApplePayRequest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * 
 * @param {function} [onInitiate] a function that returns back a valid opaque ApplePay session object by calling the backend server.
 * @param {function} [onAuthorize] a function that returns a boolean value determining whether to authorize the payment or not.
 * @param {function} onCancel a function that will be executed when the user clicks on cancel button in the payment sheet.
 * @param {function} onError a function that will be executed when there are any unprecendented errors.
 * @returns node
 */
var ApplePayButton = function ApplePayButton(_ref) {
  var onInitiate = _ref.onInitiate,
    onAuthorize = _ref.onAuthorize,
    onCancel = _ref.onCancel,
    onError = _ref.onError;
  // eslint-disable-next-line no-unused-vars
  var _useApplePayScriptRed = (0, _ApplePayScript.useApplePayScriptReducer)(),
    _useApplePayScriptRed2 = _slicedToArray(_useApplePayScriptRed, 2),
    options = _useApplePayScriptRed2[0],
    _ = _useApplePayScriptRed2[1];
  var version = options.version ? options.version : 3;
  return (
    /*#__PURE__*/
    // We mainly use w3C standard PaymentRequest API. But for devices running on iOS version<11.3 we use ApplePayJS API as a fallback
    _react.default.createElement("div", {
      className: "apple-pay-button",
      lang: options.languageCode,
      onClick: function onClick() {
        return window.PaymentRequest ? new _ApplePayRequest.default(options, {
          onCancel: onCancel,
          onAuthorize: onAuthorize,
          onInitiate: onInitiate,
          onError: onError
        }).createRequest('paymentRequestAPI', version) : new _ApplePayRequest.default(options, {
          onCancel: onCancel,
          onAuthorize: onAuthorize,
          onInitiate: onInitiate,
          onError: onError
        }).createRequest('applePayJsAPI', version);
      }
    })
  );
};
ApplePayButton.propTypes = {
  onCancel: _propTypes.default.func,
  onAuthorize: _propTypes.default.func.isRequired,
  onInitiate: _propTypes.default.func.isRequired,
  onError: _propTypes.default.func
};
var _default = ApplePayButton;
exports.default = _default;